export default __webpack_public_path__ + "static/media/SG.a47f310a.gif";